import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { FollowState } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollows } from "./useFollows"
import { useAccount } from "src/hooks/account"

const defaultValue: Follow[] = []
/*
 * this hook returns the follows that represent this account sharing its data
 * with another account or itself
 */
export function useFollowingFollows(): Follow[] {
  const { data: follows } = useFollows()
  const { data: account } = useAccount()

  return useMemo(
    () => account === undefined || follows == undefined
      ? defaultValue
      : follows.filter(
        (follow) => follow.deleted_at === null && (
          follow.is_self ||
          follow.following_account_id !== account.id
        ) && follow.state !== FollowState.Terminated,
      ),
    [
      follows,
      account,
    ],
  )
}

